export default {
  GET_PAYMENT_METHODS (state, data) {
    state.payment_methods = data.data
  },
  GET_ALL_PAYMENT_METHODS (state, data) {
    state.all_payment_methods = data.data
  },
  GET_PAYMENT_METHOD (state, data) {
    state.payment_method = data.data
  },
  GET_DELETED_PAYMENT_METHODS (state, data) {
    state.deleted_payment_methods = data.data
  },
  GET_ALL_CREDIT_CARD_ACCOUNTS (state, data) {
    state.payment_gateways = data.data
  },
  JENGA_API_TOKEN (state, data) {
    state.jenga_auth = data.data
  },
  GET_ALL_PAYMENT_CHECKOUT (state, data) {
    
    state.payment_options = data.data
  },
  GET_MPESA_TRANSACTIONS (state, data) {
    state.mpesa_transactions = data
  }
}
